module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clear-kit"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-cta-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showHero"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "landing-page-lets-meet"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.heroSection.button.url,
      "title": _vm.content.heroSection.button.text
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.text),
      expression: "content.heroSection.button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.button.url),
      expression: "content.heroSection.button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.aboutSection[0].hideSection || _vm.content.aboutSection[0].hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.aboutSection[0].hideSection || content.aboutSection[0].hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper about-section landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility",
    staticStyle: {
      "top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].hideSection),
      expression: "content.aboutSection[0].hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSection"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.aboutSection[0].hideSection) ? _vm._i(_vm.content.aboutSection[0].hideSection, null) > -1 : (_vm.content.aboutSection[0].hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.aboutSection[0].hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.aboutSection[0], "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.aboutSection[0], "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.aboutSection[0], "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSection"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[0].title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].title),
      expression: "content.aboutSection[0].title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0], "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[0].title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[0].text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].text),
      expression: "content.aboutSection[0].text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0], "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[0].text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-action-wrapper"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.aboutSection[0].button.url,
      "title": _vm.content.aboutSection[0].button.text
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[0].button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].button.text),
      expression: "content.aboutSection[0].button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0].button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[0].button.url),
      expression: "content.aboutSection[0].button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[0].button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[0].button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[1].title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].title),
      expression: "content.aboutSection[1].title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1], "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[1].title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-description"
  }, [(!_vm.pageEditMode) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.aboutSection[1].text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].text),
      expression: "content.aboutSection[1].text"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].text)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1], "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[1].text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-action-wrapper"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.aboutSection[1].button.url,
      "title": _vm.content.aboutSection[1].button.text
    }
  }, [_vm._v(_vm._s(_vm.content.aboutSection[1].button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].button.text),
      expression: "content.aboutSection[1].button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1].button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.aboutSection[1].button.url),
      expression: "content.aboutSection[1].button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.aboutSection[1].button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.aboutSection[1].button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.clientSection.hideSection || _vm.content.clientSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper clients-section about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.hideSection),
      expression: "content.clientSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showClient"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.clientSection.hideSection) ? _vm._i(_vm.content.clientSection.hideSection, null) > -1 : (_vm.content.clientSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.clientSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.clientSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.clientSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showClient"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.title),
      expression: "content.clientSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.clientSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.clientSection.description),
      expression: "content.clientSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.clientSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.clientSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.clientSection.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logos flex-section"
  }, [(_vm.slidesReady) ? _c('slick', {
    ref: "slick",
    staticClass: "clients-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.content.clientSection.logos), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(item.image),
        "alt": item.altImage
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-slider-change",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchSliderModal()
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.howItWorksSection.hideSection || _vm.content.howItWorksSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper how-it-works-section landing-page-wrapper__gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.hideSection),
      expression: "content.howItWorksSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHIW"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.howItWorksSection.hideSection) ? _vm._i(_vm.content.howItWorksSection.hideSection, null) > -1 : (_vm.content.howItWorksSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.howItWorksSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.howItWorksSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.howItWorksSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showHIW"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.howItWorksSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.howItWorksSection.title),
      expression: "content.howItWorksSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.howItWorksSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.howItWorksSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.howItWorksSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "list flex-section"
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "content-slider"
  }, [_c('slick', {
    ref: "contentSlick",
    staticClass: "slider",
    attrs: {
      "options": _vm.slickOptionsContent
    }
  }, _vm._l((_vm.content.howItWorksSection.sections), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "list-item-icon"
    }, [_c('div', {
      staticClass: "content",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "title": _vm.getHighImageAlt(item)
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "landing-page-image-upload",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(item)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-title"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item-description"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "content",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()])])
  }), 0)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.subscribeSection.hideSection || _vm.content.subscribeSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper subscribe-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.hideSection),
      expression: "content.subscribeSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showSubscribe"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.subscribeSection.hideSection) ? _vm._i(_vm.content.subscribeSection.hideSection, null) > -1 : (_vm.content.subscribeSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.subscribeSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.subscribeSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.subscribeSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showSubscribe"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.title),
      expression: "content.subscribeSection.title"
    }],
    staticClass: "section-title center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subscribeSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.subscribeSection.description),
      expression: "content.subscribeSection.description"
    }],
    staticClass: "section-description center",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.subscribeSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.subscribeSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.subscribeSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('form', {
    staticClass: "subscribe-form center",
    attrs: {
      "name": "form",
      "method": "POST",
      "action": "https://forms.sign-up.to/15008/3116"
    }
  }, [_c('div', {
    staticClass: "subscribe-form-group",
    class: [{
      'active': _vm.subscribeForm.firstname !== '' || _vm.subscribeForm.firstnameFocus,
      'has-error': _vm.subscribeForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "subscribe-form-firstname"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.firstname),
      expression: "subscribeForm.firstname"
    }],
    attrs: {
      "id": "subscribe-form-firstname",
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.subscribeForm.firstname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.firstnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.firstnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subscribe-form-group",
    class: [{
      'active': _vm.subscribeForm.lastname !== '' || _vm.subscribeForm.lastnameFocus,
      'has-error': _vm.subscribeForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "subscribe-form-lastname"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.lastname),
      expression: "subscribeForm.lastname"
    }],
    attrs: {
      "id": "subscribe-form-lastname",
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.subscribeForm.lastname)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.lastnameFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.lastnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subscribe-form-group",
    class: [{
      'active': _vm.subscribeForm.email !== '' || _vm.subscribeForm.emailFocus,
      'has-error': _vm.subscribeForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "subscribe-form-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscribeForm.email),
      expression: "subscribeForm.email"
    }],
    attrs: {
      "id": "subscribe-form-email",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.subscribeForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.subscribeForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.subscribeForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscribeForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "subscribe-form-action",
    attrs: {
      "name": "subscribe",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.subscribeMe()
      }
    }
  }, [_vm._v("Subscribe")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.featuresSection.hideSection || _vm.content.featuresSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper features-section landing-page-wrapper__gray about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.featuresSection.hideSection),
      expression: "content.featuresSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFeatures"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.featuresSection.hideSection) ? _vm._i(_vm.content.featuresSection.hideSection, null) > -1 : (_vm.content.featuresSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.featuresSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.featuresSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.featuresSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showFeatures"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  }, [_vm._l((_vm.content.featuresSection.items), function(item, index) {
    return _c('div', {
      staticClass: "feature-item"
    }, [(!_vm.pageEditMode && !_vm.getDeviceType('desktop')) ? _c('div', {
      staticClass: "feature-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && !_vm.getDeviceType('desktop')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "feature-image",
      class: [{
        'iframe': item.video
      }],
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": !item.video || item.video === '' ? item.altImage : ''
      }
    }, [(!_vm.pageEditMode && item.video) ? _c('iframe', {
      attrs: {
        "id": "player",
        "frameborder": "0",
        "webkitAllowFullScreen": "",
        "mozallowfullscreen": "",
        "allowFullScreen": "",
        "height": "340",
        "width": "600",
        "src": _vm.getVideoUrl(item.video)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "landing-page-image-upload",
      attrs: {
        "for": 'feature-image-upload-' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'feature-image-upload-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e(), _vm._v(" "), (!item.image || item.image === '') ? [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.video),
        expression: "item.video"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Video url"
      },
      domProps: {
        "value": (item.video)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "video", $event.target.value)
        }
      }
    }) : _vm._e()] : [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e()]], 2), _vm._v(" "), _c('div', {
      staticClass: "feature-content"
    }, [(!_vm.pageEditMode && _vm.getDeviceType('desktop')) ? _c('div', {
      staticClass: "feature-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM() && _vm.getDeviceType('desktop')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "feature-title",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item title",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "feature-description",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode && item.button.text !== '') ? _c('a', {
      staticClass: "feature-link",
      attrs: {
        "href": item.button.url,
        "title": item.button.text
      }
    }, [_vm._v(_vm._s(item.button.text))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "feature-description",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Item description",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.button.text),
        expression: "item.button.text"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button text",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.button.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.button, "text", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.button.url),
        expression: "item.button.url"
      }],
      staticClass: "landing-page-button-edit",
      attrs: {
        "data-gramm_editor": "false",
        "placeholder": "Button url",
        "data-lpignore": "true",
        "rows": "1"
      },
      domProps: {
        "value": (item.button.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.button, "url", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.featuresSection.items, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('features')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.footerCTASection.hideSection || _vm.content.footerCTASection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.footerCTASection.hideSection || content.footerCTASection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper footer-cta-section landing-page-wrapper__blue about-page"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.hideSection),
      expression: "content.footerCTASection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showFooter"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.footerCTASection.hideSection) ? _vm._i(_vm.content.footerCTASection.hideSection, null) > -1 : (_vm.content.footerCTASection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.footerCTASection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.footerCTASection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.footerCTASection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.footerCTASection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showFooter"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "section-title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footerCTASection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.title),
      expression: "content.footerCTASection.title"
    }],
    staticClass: "section-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "section-description",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footerCTASection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.description),
      expression: "content.footerCTASection.description"
    }],
    staticClass: "section-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [_c('div', {
    staticClass: "cta-content"
  }, [_c('div', {
    staticClass: "section-actions"
  }, [(!_vm.pageEditMode) ? _c('a', {
    staticClass: "section-action",
    attrs: {
      "href": _vm.content.footerCTASection.button.url,
      "title": _vm.content.footerCTASection.button.text
    }
  }, [_vm._v(_vm._s(_vm.content.footerCTASection.button.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-buttons-edit"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.button.text),
      expression: "content.footerCTASection.button.text"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button text",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.button.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection.button, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.footerCTASection.button.url),
      expression: "content.footerCTASection.button.url"
    }],
    staticClass: "landing-page-button-edit",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Button url",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.footerCTASection.button.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.footerCTASection.button, "url", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "iconPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Upload icons for: " + _vm._s(_vm.activePopup.title))]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sliderModalShown && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "sliderPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change slider items")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [_vm._l((_vm.content.clientSection.logos), function(item, index) {
    return _c('div', {
      staticClass: "logo-item"
    }, [_c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-normal-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-normal-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Image alt"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "modal-item"
    }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
      staticClass: "modal-image",
      style: ({
        backgroundImage: _vm.getImage(item.imageHigh)
      })
    }, [_c('label', {
      staticClass: "step-item-upload",
      attrs: {
        "for": 'logo-high-' + index
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": 'logo-high-' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'imageHigh')
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImageHigh),
        expression: "item.altImageHigh"
      }],
      attrs: {
        "type": "text",
        "placeholder": "High contrast image alt"
      },
      domProps: {
        "value": (item.altImageHigh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImageHigh", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.url),
        expression: "item.url"
      }],
      attrs: {
        "placeholder": "url"
      },
      domProps: {
        "value": (item.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "url", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "landing-page-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.clientSection.logos, index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection('logos')
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ed4bce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ClearKit.vue
// module id = 885
// module chunks = 1